import styled from 'styled-components';
import { Link } from '../../../../../../common/components/Link';
import { Heading } from '../../../../../../common/components/Typography/Heading/Heading';
import { textEllipsis } from '../../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { FontWeight, STANDARD_TRANSITION } from '../../../../../../common/styles/constants';

export const StyledLink = styled(Link)`
  ${STANDARD_TRANSITION};
  color: ${ThemeColours.mono900};
  text-decoration: none;

  &:after {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const CardHeading = styled(Heading)`
  color: ${ThemeColours.mono900};
  font-size: 18px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 26px;
  margin: 0;
  margin-top: 0;
  ${textEllipsis};

  &:active {
    ${StyledLink}:after {
      background: rgba(0, 0, 0, 0.04);
    }
  }
`;
